import { render, staticRenderFns } from "./EditAvatar.vue?vue&type=template&id=f4154422&scoped=true&"
import script from "./EditAvatar.vue?vue&type=script&lang=js&"
export * from "./EditAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EditAvatar.vue?vue&type=style&index=0&id=f4154422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4154422",
  null
  
)

export default component.exports